module.exports = __webpack_public_path__ + "static/img/button-stm.bfada43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/button-stm.png
// module id = sALL
// module chunks = 1